export const getCardInfo = (cardData) => {
  return (
    <div className="card-data">
      {cardData.map((data, index) => {
        // Handle nested structure if needed
        const key = data.key;
        const value = data.value;

        if (!key || !value) {
          console.error("Invalid cardData format:", data);
          return null; // Skip invalid entries
        }

        return (
          <div key={index} className="key-value-pair">
            <div className="key-value-pair-key">{key}</div>: <div className="key-value-pair-value">{value}</div>
          </div>
        );
      })}
    </div>
  );
};
